// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1CHyt","box":"WorkspacesBox_box__3QJIX","node":"WorkspacesBox_node__81OZS"};